// Helper Method to check if something in section is checked
export const checkIfSectionSelected = (arr, button) => {
    let section = false;
    if (button) {
        section = arr.clinicianAttended.check || arr.sendBloods.check || arr.doctorReview.check;
    } else {
        for (let i in arr) {
            if (arr[i] === true) {
                section = true;
                break;
            }
        }
    }
    return section;
};

export class SepsisPathwayStatus {
    static #_incomplete = 0;
    static #_ended = 1;
    static #_canceled = 2;

    static get INCOMPLETE() {
        return this.#_incomplete;
    }

    static get ENDED() {
        return this.#_ended;
    }

    static get CANCELED() {
        return this.#_canceled;
    }
}